export default __webpack_public_path__ + "static/media/tvseries.6fc81508.svg";